import {
  type FlightSearchLocationState,
  MobileFlightSearchStep,
} from "../../../search/reducer";

/**
 * Builds the location passed to `history.replace` when editing dates from
 * flight results. The raw query string is preserved so the existing route,
 * dates, and passenger context remain available on the search calendar.
 */
export const getDateEditSearchLocation = (search: string) => ({
  pathname: "/flights/search",
  search,
  state: {
    initialMobileSearchStep: MobileFlightSearchStep.CalendarPicker,
  } satisfies FlightSearchLocationState,
});

interface DateEditNavigationHistory {
  location: { search: string };
  replace: (location: ReturnType<typeof getDateEditSearchLocation>) => void;
}

/**
 * Returns the date-edit navigation handler only for Nubank mobile, leaving
 * desktop and other tenants on their existing calendar behavior.
 */
export const getDateEditCalendarHandler = (
  isNubank: boolean,
  matchesMobile: boolean,
  history: DateEditNavigationHistory
) =>
  isNubank && matchesMobile
    ? () => history.replace(getDateEditSearchLocation(history.location.search))
    : undefined;
